import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export default {
  namespaced: true,
  state: {
    groups: [],
    attributes: [],
    currentSelected: {
      group: {},
      attribute: {},
    },
  },
  actions,
  mutations,
  getters,
};
